import { render, staticRenderFns } from "./SysMsgView.vue?vue&type=template&id=008f8c64"
import script from "./SysMsgView.vue?vue&type=script&lang=js"
export * from "./SysMsgView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports